/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Dashboard_ScalabilityInputs */



/**
* | output |
* | --- |
* | "Scalability" |
*
* @param {Menu_Dashboard_ScalabilityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const menu_dashboard_scalability = /** @type {((inputs?: Menu_Dashboard_ScalabilityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Dashboard_ScalabilityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Scalability")
});